const IV_STRING = 'SgVkYp3s5v8y/B?E'

function getIv() {
  return new TextEncoder().encode(IV_STRING)
}

function bufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  const chunkSize = 0x8000
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize))
  }
  return btoa(binary)
}

function base64ToBuffer(base64) {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes.buffer
}

/**
 * AES-256-CBC encrypt using a non-extractable CryptoKey (Web Crypto).
 * Output Base64 matches prior CryptoJS AES-CBC ciphertext format for the backend.
 */
export const aes_256_encrypt = async (cryptoKey, data) => {
  const jsonData = JSON.stringify(data)
  const encoded = new TextEncoder().encode(jsonData)
  const encryptedBuffer = await window.crypto.subtle.encrypt(
    { name: 'AES-CBC', iv: getIv() },
    cryptoKey,
    encoded
  )
  return bufferToBase64(encryptedBuffer)
}

export const aes_256_decrypt = async (cryptoKey, encData) => {
  const decryptedBuffer = await window.crypto.subtle.decrypt(
    { name: 'AES-CBC', iv: getIv() },
    cryptoKey,
    base64ToBuffer(encData)
  )
  const json = new TextDecoder().decode(decryptedBuffer)
  return JSON.parse(json)
}
